import React from 'react';
import { Link, Skeleton, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * One breadcrumb entry.
 *
 * Props:
 *   isLoading (bool)     - Show a skeleton instead of `children`.
 *   width     (number)   - Skeleton width while loading.
 *   to        (string)   - Optional relative route; renders a link instead of text.
 *   onClick   (function) - Optional click handler for the link.
 *   children  (node)     - The crumb's label once loaded.
 */
function BreadcrumbCrumb({ isLoading, width = 120, to, onClick, children }) {
  if (isLoading) return <Skeleton variant="text" width={width} />;
  if (to) {
    return (
      <Link component={RouterLink} to={to} relative="path" onClick={onClick}>
        {children}
      </Link>
    );
  }
  return <Typography>{children}</Typography>;
}

export default BreadcrumbCrumb;
